/**
 * About Page Content
 *
 * Content for the about page breadcrumb and all sub-sections.
 */

const aboutContent = {
  breadcrumb: {
    subtitle: 'About Us',
    title: 'OUR STORY',
  },

  section: {
    subtitle: 'who we are',
    heading: 'A modern restaurant with a menu that will make your mouth water. Servicing delicious food',
    highlightText: 'since 45 years',
    headingEnd: '. Enjoy our seasonal menu and experience the beauty of naturalness',
    text: 'Lorem Ipsum is simply dummy text of the printingand typesetting industry lorem Ipsum has been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book It has survived.',
    author: 'andrew joe - founder',
    videoUrl: '//www.youtube.com/embed/ZETY_l3GVQg?autoplay=1&autohide=1&fs=1&rel=0&hd=1&wmode=transparent&enablejsapi=1&html5=1',
    videoLink: 'https://www.youtube.com/watch?v=ZETY_l3GVQg',
  },

  stats: [
    { id: 1, value: 150, suffix: '+', label: 'daily order', duration: 2000 },
    { id: 2, value: 82, suffix: '+', label: 'Special Dishes', duration: 1500 },
    { id: 3, value: 35, suffix: '+', label: 'expert chef', duration: 1000 },
    { id: 4, value: 10, suffix: '+', label: 'awards won', duration: 1000 },
  ],

  services: {
    subtitle: 'our services',
    title: 'Exquisite Restaurant in City',
    items: [
      { id: 1, icon: 's-icon-1.png', title: 'Door Delivery', text: 'Lorem Ipsum is simply dummy printing and typeset industry lorem Ipsum has been.' },
      { id: 2, icon: 's-icon-2.png', title: 'Fine Dining', text: 'Lorem Ipsum is simply dummy printing and typeset industry lorem Ipsum has been.' },
      { id: 3, icon: 's-icon-3.png', title: 'Outdoor Catering', text: 'Lorem Ipsum is simply dummy printing and typeset industry lorem Ipsum has been.' },
      { id: 4, icon: 's-icon-4.png', title: 'Banquets Hall', text: 'Lorem Ipsum is simply dummy printing and typeset industry lorem Ipsum has been.' },
    ],
  },

  whyUs: {
    subtitle: 'why choose us',
    title: 'Our Strength',
    items: [
      { id: 1, image: 'featured-4.jpg', icon: 'why-icon-1.png', title: 'Hygienic Food' },
      { id: 2, image: 'featured-5.jpg', icon: 'why-icon-2.png', title: 'Fresh Environment' },
      { id: 3, image: 'featured-6.jpg', icon: 'why-icon-3.png', title: 'Skilled Chefs' },
      { id: 4, image: 'featured-7.jpg', icon: 'why-icon-4.png', title: 'Event & Party' },
    ],
  },

  gallery: {
    images: ['gallery-1.jpg', 'gallery-2.jpg', 'gallery-3.jpg'],
  },

  testimonials: {
    subtitle: 'testimonials',
    title: 'What People Are Saying',
    items: [
      { id: 1, text: 'The taste of food was really amazing, Wow! outstanding dinner made by Master chef John Rute, I never forget this delicious food experience.', author: 'William Joe', location: 'New York', image: 'author-thumb-4.jpg', rating: 5 },
      { id: 2, text: 'Hygienic food & fresh environment, everyone had a wonderful delight experience. It was FABULOUS! great experience at The Italian gourmet.', author: 'Theresa Tin', location: 'Chicago', image: 'author-thumb-5.jpg', rating: 5 },
      { id: 3, text: 'Special treat to dine, It was a wow experience food was really delicious! outstanding dinner made by Master chef, food experience was unforgettable!', author: 'Michel Byrd', location: 'Denmark', image: 'author-thumb-6.jpg', rating: 5 },
    ],
  },

  winningChef: {
    chefSection: {
      subtitle: '35 year of experience',
      title: 'Award Winning Chef',
      text: 'Lorem Ipsum is simply dummy text of the printingand typesetting industry lorem Ipsum has been the industrys standard dummy text ever since the when an unknown printer took a galley of type.',
      author: 'Henry - EXCUTIVE CHEF',
      ctaText: 'meet our team',
      ctaLink: '#',
    },
    eventSection: {
      subtitle: 'Delightful Experience',
      title: 'Dinner, Event or Party?',
      text: 'Lorem Ipsum is simply dummy text of the printingand typesetting industry lorem Ipsum has been the industrys standard dummy text ever since the when an unknown printer took a galley of type.',
      ctaText: 'Discover Now',
      ctaLink: '#',
    },
  },
};

export default aboutContent;
